import {
  SET_CATEGORY_PAGE_DATA,
  SET_CATEGORY_TOTAL_RECORDS,
  SET_CATEGORY_PAGE,
  EDIT_CATEGORY,
  ADD_CATEGORY,
  DELETE_CATEGORY,
  CATEGORY_LOADING,
  CATEGORY_FAILURE,
  GET_CATEGORY,
  SET_CATEGORY_REDIRECT_URL,
  GET_ALL_CATEGORY
} from "./category-constant";

import {
  handleLoading,
  handleFailure,
  handleSetRedirectUrl,
  handleGetData,
  handleSetTotalRecords,
  handleSetPage,
  handleEditItem,
  handleAddItem,
  handleDeleteItems,
} from "../utils/reducerUtils";

// Initial state
const initialState = {
  categoryList: {},
  totalRecords: 0,
  totalPages: 0,
  currentPage: 1,
  loading: false,
  error: null,
  redirectTo: false,
  allCategory:[],
};

export const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CATEGORY_LOADING:
      return handleLoading(state, action);

    case CATEGORY_FAILURE:
      return handleFailure(state, action);

    case SET_CATEGORY_REDIRECT_URL:
      return handleSetRedirectUrl(state, action);

    case GET_CATEGORY:
      return handleGetData(state, action, "categoryList");

    case SET_CATEGORY_TOTAL_RECORDS:
      return handleSetTotalRecords(state, action);

    case SET_CATEGORY_PAGE:
      return handleSetPage(state, action);

    case ADD_CATEGORY:
      return handleAddItem(state, action, "categoryList", "categoryId");

    case EDIT_CATEGORY:
      return handleEditItem(state, action, "categoryList", "categoryId");

    case DELETE_CATEGORY:
      return handleDeleteItems(state, action, "categoryList", "categoryId");

    case GET_ALL_CATEGORY:
      return {...state,allCategory:action.payload};
    default:
      return state;
  }
};
